export class Paginacion {
    pagina: number;
    registros: number;
    totalPaginas: number;
    totalRegistros: number;
    indiceMin: number;
    indiceMax: number;

    private DEFAULT_REGISTROS = 10;

    constructor(paginacion: {pagina?: number, registros?: number, totalPaginas?: number, totalRegistros?: number}) {
      this.pagina = paginacion.pagina;
      this.registros = paginacion.registros;
      this.totalRegistros = paginacion.totalRegistros;
      this.totalPaginas = paginacion.totalPaginas;
    }

    primera() { this.pagina = 1; }
    siguiente() { if (this.pagina < this.totalPaginas) { this.pagina++; } }
    anterior() { if (this.pagina !== 1) {this.pagina--; } }
    ultima() { this.pagina = this.totalPaginas; }
}
